import React from 'react';
import { Database, Shield, Search, AlertTriangle } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for Data Protection feature
 * Displays information about the Data Protection feature and its benefits
 */
export const DataProtectionFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Data Protection"
      description="Monitor, detect, and respond to data leaks and credential exposures that could compromise your organization's security."
      icon={<Database className="h-8 w-8 text-blue-600" />}
      featureName="data-protection"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Database className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Leak Monitoring</h3>
          </div>
          <p className="text-gray-400">
            Continuously monitor for leaked credentials, sensitive data, and confidential information across the web.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Search className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Credential Search</h3>
          </div>
          <p className="text-gray-400">
            Search for exposed credentials and sensitive data related to your organization across various data sources.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <AlertTriangle className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Breach Alerts</h3>
          </div>
          <p className="text-gray-400">
            Receive real-time alerts when your organization's data appears in new leaks or breaches.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Shield className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Remediation Guidance</h3>
          </div>
          <p className="text-gray-400">
            Get actionable recommendations to mitigate the impact of data leaks and prevent future exposures.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
